import { render, staticRenderFns } from "./sub-partner.vue?vue&type=template&id=7917e05a&scoped=true&"
import script from "./sub-partner.vue?vue&type=script&lang=js&"
export * from "./sub-partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7917e05a",
  null
  
)

export default component.exports